import { useEffect } from 'react'
import { EventTypes, track, trackExperimentViewed } from '@mc/track-event'
import { useBucket } from '@mc/experiments-react'

import { STRAIGHT_TO_QR_EXP_FLAG } from './constants'

const STRAIGHT_TO_QR_EVENT_NAME = 'Straight to Quiz Results'
const STRAIGHT_TO_QR_BANNER_EVENT_NAME =
  'Straight to Quiz Results Banner Viewed'
const STRAIGHT_TO_QR_BANNER_EDIT_EVENT_NAME = 'Straight to Quiz Results Edit'

export const trackStraightToQR = (
  categoryInterests: number[],
  subcatInterests: number[],
) => {
  track(STRAIGHT_TO_QR_EVENT_NAME, {
    categories: categoryInterests.join(','),
    subcategories: subcatInterests.join(','),
  })
}

export const trackStraightToQRExperimentViewed = () => {
  trackExperimentViewed(STRAIGHT_TO_QR_EXP_FLAG)
}

export const useTrackStraightToQRPageLoadExperimentViewed = () => {
  const variant = useBucket(STRAIGHT_TO_QR_EXP_FLAG)

  useEffect(() => {
    if (variant) {
      track(EventTypes.EXPERIMENT_VIEWED, {
        experimentName: `${STRAIGHT_TO_QR_EXP_FLAG}_pl`,
        variationName: variant,
      })
    }
  }, [variant])
}

export const trackStraightToQRBannerViewed = (
  categoryInterests: string | string[] | undefined,
  subcatInterests: string | string[] | undefined,
) => {
  track(STRAIGHT_TO_QR_BANNER_EVENT_NAME, {
    categories: categoryInterests,
    subcategories: subcatInterests,
  })
}

export const trackStraightToQRBannerClicked = (
  categoryInterests: string | string[] | undefined,
  subcatInterests: string | string[] | undefined,
) => {
  track(STRAIGHT_TO_QR_BANNER_EDIT_EVENT_NAME, {
    categories: categoryInterests,
    subcategories: subcatInterests,
  })
}
